import {useTaskSharingDialogOptional} from '../contexts/TaskSharingDialogContext'
import {TaskSharingDialog} from './TaskSharingDialog'

export function TaskSharingDialogRendered() {
  const sharingDialog = useTaskSharingDialogOptional()
  if (!sharingDialog?.dialogState.isOpen || !sharingDialog.dialogState.taskId) return null
  const {taskId, repoOwner, repoName, isShared, returnFocusRef} = sharingDialog.dialogState
  return (
    <TaskSharingDialog
      taskId={taskId}
      repoOwner={repoOwner}
      repoName={repoName}
      isShared={!!isShared}
      closeDialog={sharingDialog.closeSharingDialog}
      returnFocusRef={returnFocusRef}
    />
  )
}
